module.exports = __webpack_public_path__ + "img/Kino Ravensburg.d005ed03.jpg";